import { Controller } from "@hotwired/stimulus"

// Help article with two paths (Phelipe 2026-10-21): big cards up top, and
// nothing below until one is picked; then only that card's steps show and
// the card stays highlighted. A link straight to #<key> opens that one.
export default class extends Controller {
  static targets = ["card", "panel"]

  connect() {
    const key = window.location.hash.replace("#", "")
    if (this.panelTargets.some(p => p.dataset.key === key)) this._show(key, false)
  }

  pick(event) {
    event.preventDefault()
    const key = event.currentTarget.dataset.key
    this._show(key, true)
    history.replaceState(null, "", `#${key}`)
  }

  _show(key, scroll) {
    this.panelTargets.forEach(p => { p.hidden = p.dataset.key !== key })
    this.cardTargets.forEach(c => {
      const on = c.dataset.key === key
      c.setAttribute("aria-expanded", on ? "true" : "false")
      c.classList.toggle("help-choice-on", on)
    })
    if (scroll) {
      const panel = this.panelTargets.find(p => p.dataset.key === key)
      panel?.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }
}
